module.exports = __webpack_public_path__ + "static/media/logo@2x.314bc764.webp";